<template>
    <b-form @submit.prevent="getPersons(formData)">
        <b-form-group :label="$t('person.login')">
            <b-form-input v-model="formData.login"></b-form-input>
        </b-form-group>
        <div class="mx-0 row justify-content-end">
            <a v-if="!show" href="javascript:" @click="toggleInputs">{{ $t('general.additional') }}</a>
        </div>
        <div v-if="show">
            <b-form-group :label="$t('person.firstname')">
                <b-form-input v-model="formData.firstName"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.lastname')">
                <b-form-input v-model="formData.surname"></b-form-input>
            </b-form-group>
            <b-form-row class="mx-0 justify-content-end">
                <a v-if="show" href="javascript:" @click="toggleInputs">{{ $t('general.hide') }}</a>
            </b-form-row>
        </div>
        <b-form-row class="mx-0 mt-3 justify-content-end">
            <b-button type="submit" variant="success" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */
export default {
    name: 'PersonSearchForm',
    data () {
        return {
            show: false,
            formData: {
                login: '',
                firstName: '',
                surname: '',
                offset: this.offset,
                pageSize: this.pageSize
            }
        }
    },
    props: {
        fetch: Function,
        offset: Number,
        pageSize: Number,
        setOffset: Function
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        toggleInputs() {
            this.show = !this.show
        },
        getPersons(formData) {
            if (this.offset !== 0) {
                this.setOffset(0)
            } else {
                this.fetch(formData)
            }
        }
    },
    watch: {
        offset(newValue) {
            this.formData.offset = newValue
            this.fetch(this.formData)
        }
    }
}
</script>
